import { AlternateMenuItemOnClick } from "components/Category/CrudMenu";
import React, { Dispatch, ReactElement, ReactNode } from "react";

type ItemProps = {
  onClick(): void | AlternateMenuItemOnClick;
  icon: any;
  name: string;
  imgAlt: string;
  disabled?: boolean;
  permissionKey?: string | undefined;
  customItem?: (props?: any) => ReactNode;
  additionalDataIDs?: any;
  position: "RightMenu" | "TableRowOption";
  dispatch: Dispatch<any>;
};

type Props = ItemProps;

const Item: React.FC<Props> = ({
  onClick,
  name,
  disabled,
  customItem,
  dispatch,
  ...otherProps
}) => {
  return customItem ? (
    <>{customItem({ name, disabled, onClick, dispatch, ...otherProps })}</> //not customItem() if ReactNode
  ) : (
    <div
      className={disabled ? "Item Disabled" : "Item"}
      // onClick={customItem?.action ?? onClick}
      onClick={onClick}
    >
      {/* {customItem && customItem({ item: { name } })} */}
      {/* {customItem && customItem.node(name)} */}
      {!customItem && <span>{name}</span>}
    </div>
  );
};

export { Item };
